import React from "react";
import FlowCard from "../components/FlowCard";
export default function ProfileTesting() {
    return (
        <div className="container-fluid">

            <h3 className="mb-4">

                ABHA Profile Testing

            </h3>

            <FlowCard

                title="Get Profile Details"

                endpoint="abdm/get-profile-details/"

                method="GET"

                buttonText="Get Profile"

                fields={[]}

            />

            <FlowCard

                title="Request Email Verification"

                endpoint="abdm/request-email-verification/"

                buttonText="Request Email Verification"

                fields={[
                    {
                        name: "email",
                        label: "Email",
                        type: "email",
                        required: true
                    }
                ]}

            />

            <FlowCard

                title="Update Mobile OTP"

                endpoint="abdm/update-request-mobile-otp/"

                buttonText="Request OTP"

                fields={[]}

            />

            <FlowCard

                title="Verify Updated Mobile"

                endpoint="abdm/update-verify-mobile-otp/"

                buttonText="Verify OTP"

                fields={[
                    {
                        name: "otp",
                        label: "OTP",
                        required: true
                    }
                ]}

            />

            <FlowCard

                title="QR Code"

                endpoint="abdm/abha/profile/qr-code/"

                method="GET"

                buttonText="Generate QR"

                fields={[]}

            />

        </div>
    );
}